export default {
    VISITA_REALIZADA: 1,
    VISITA_RECUSADA: 2,
    AUSENTE: 3,
}